/**CORE LIBRARIES IMPORT */
import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import DummyProductImage from "./DummyImage";

const fadeOnly = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const productList = [
  {
    title: "Tin Ingots",
    subtitle: "High-Purity 99.9% Pure Tin",
    category: "Ingots",
    type: "tin",
    desc: "Manufactured from prime grade metals for soldering, alloy making, and plating applications.",
  },
  {
    title: "Lead Ingots",
    subtitle: "Refined Pure Lead Ingots",
    category: "Ingots",
    type: "lead",
    desc: "Clean refined lead ingots for batteries, shielding, cable jacketing, and chemical industries.",
  },
  {
    title: "Solder Wire",
    subtitle: "Electronics & PCB Solder Wire",
    category: "Solder",
    type: "solder",
    desc: "High electrical conductivity solder wire ensuring smooth melting and durable joints.",
  },
  {
    title: "Solder Stick (63/37)",
    subtitle: "Eutectic Solder Alloy Bar",
    category: "Solder",
    type: "solder",
    desc: "63% Tin / 37% Lead eutectic formulation for instant solidifying and zero dross formation.",
  },
  {
    title: "Star Solder Stick",
    subtitle: "Premium Grade Solder Stick",
    category: "Solder",
    type: "solder",
    desc: "Precision star solder stick designed for efficient metal joining and tinning applications.",
  },
  {
    title: "Small Solder Ingot",
    subtitle: "Compact Industrial Ingot",
    category: "Ingots",
    type: "tin",
    desc: "Ideal for smaller wave solder pots, dip soldering, and precision alloy blending.",
  },
  {
    title: "Long Solder Ingot",
    subtitle: "Extended Heavy Solder Bar",
    category: "Ingots",
    type: "tin",
    desc: "Heavy-duty extended solder ingot engineered for continuous industrial manufacturing lines.",
  },
  {
    title: "Solder Paste",
    subtitle: "SMT & Electronics Paste",
    category: "Solder",
    type: "solder",
    desc: "High reliability solder paste tailored for surface mount technology (SMT) assembly.",
  },
  {
    title: "Copper Axe & Round Bar",
    subtitle: "High-Conductivity Copper",
    category: "Copper",
    type: "copper",
    desc: "Electrolytic grade copper round bars and copper axes for electrical & mechanical uses.",
  },
];

const Products = () => {
  return (
    <motion.section
      className="expertise-section"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.1 }}
    >
      <div className="expertise-wrapper">
        {/* HEADER */}
        <motion.div className="expertise-header" variants={fadeOnly}>
          <span className="sub-title">Premium Metal Products</span>
          <h2 className="section-heading">
            JK Metal &amp; Alloys Product Catalog
          </h2>
          <p className="expertise-intro">
            Delivering ISO standard non-ferrous metals, soldering products, ingots, and copper alloys engineered for durability and high conductivity across India.
          </p>
        </motion.div>

        {/* CARDS GRID */}
        <motion.div className="products-grid-container" variants={stagger}>
          {productList.map((prod, index) => (
            <motion.div className="product-card-item" key={index} variants={fadeOnly}>
              <DummyProductImage 
                title={prod.title} 
                category={prod.category} 
                type={prod.type} 
              />
              <div className="product-card-body">
                <span className="product-card-subtitle">{prod.subtitle}</span>
                <h3 className="product-card-title">{prod.title}</h3>
                <p className="product-card-desc">{prod.desc}</p>
                <div className="product-card-footer">
                  <Link to="/product-enquiry" className="card-enquire-link">
                    Inquire Now &rarr;
                  </Link>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <div className="products-cta-box">
          <p>Looking for custom alloy specifications, chemical compositions, or bulk pricing?</p>
          <Link to="/products" className="view-all-btn">
            View All Products &amp; Technical Specs
          </Link>
        </div>
      </div>
    </motion.section>
  );
};

export default Products;

